import { render, staticRenderFns } from "./DataTableHistory.vue?vue&type=template&id=5ef7459a"
import script from "./DataTableHistory.vue?vue&type=script&lang=js"
export * from "./DataTableHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports